import { SearchFilterParamKey } from '@/app/(main)/(pages)/busca/[slug]/_consts/search-filter-params.const';
import { SearchFilterProfessionalGenderType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';

type SearchParamsRecord = Record<string, string | string[]>;

const LegacySearchFilterParamKey = {
  professionalGender: 'professionalGender',
  minDate: 'minDate',
  maxDate: 'maxDate',
} as const;

const LEGACY_PROFESSIONAL_GENDER: Partial<Record<SearchFilterProfessionalGenderType, string>> = {
  [SearchFilterProfessionalGenderType.MALE]: 'MALE',
  [SearchFilterProfessionalGenderType.FEMALE]: 'FEMALE',
};

const firstValue = (value?: string | string[]): string | undefined =>
  Array.isArray(value) ? value[0] : value;

function toLegacyProfessionalGender(value?: string | string[]): string | undefined {
  const normalized = firstValue(value)?.toLowerCase();
  const gender = Object.values(SearchFilterProfessionalGenderType).find((option) => option === normalized);

  return gender ? LEGACY_PROFESSIONAL_GENDER[gender] : undefined;
}

export function toLegacySearchFilterParams(filters: SearchParamsRecord): SearchParamsRecord {
  const {
    [SearchFilterParamKey.professionalGender]: professionalGender,
    [SearchFilterParamKey.minDate]: startDate,
    [SearchFilterParamKey.maxDate]: endDate,
    ...rest
  } = filters;

  const legacyParams: SearchParamsRecord = { ...rest };

  const legacyProfessionalGender = toLegacyProfessionalGender(professionalGender);
  if (legacyProfessionalGender) {
    legacyParams[LegacySearchFilterParamKey.professionalGender] = legacyProfessionalGender;
  }

  const minDate = firstValue(startDate);
  if (minDate !== undefined) {
    legacyParams[LegacySearchFilterParamKey.minDate] = minDate;
  }

  const maxDate = firstValue(endDate);
  if (maxDate !== undefined) {
    legacyParams[LegacySearchFilterParamKey.maxDate] = maxDate;
  }

  return legacyParams;
}
